import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import gql from 'graphql-tag';
import { Apollo } from 'apollo-angular';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { config } from '@app/app.config';
import { authenticationErrorCodes } from 'serverEnms/error-codes';

import { AuthError, AuthResponse } from 'interfaces/http';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

const LoginQuery = gql`
  mutation login($input: AuthUser!) {
    loginUser(input: $input) {
      token
    }
  }
`;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  error: AuthError;
  public errorCodes = authenticationErrorCodes;

  constructor(
    private fb: FormBuilder,
    private apollo: Apollo,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
    , private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      email: this.fb.control(''),
      password: this.fb.control('')
    });
  }

  login() {

    this.http
      .post(config.httpURL + '/api/auth/login', {
        username: this.form.value.email,
        password: this.form.value.password
      })
      .subscribe(
        (response: AuthResponse) => {
          this.error = null;
          if (response.error) {
            this.error = response.error;
            this.snackBar.open('Invalid Login', 'Dismiss', { duration: 3500 });

            return;
          }
          if (response) {
            // @ts-ignore
            this.authService.setAccessToken(response.access_token);
            window.location.pathname = '/events';
          }
        },
        error => {
          this.error = { ...error.error, code: error.error.error };
          this.snackBar.open('Invalid Login', 'Dismiss', { duration: 3500 });

        }
      );
  }
}
